export default "__VITE_ASSET__a1cb38ae__"